export class FetchTagsAction {
  static readonly type = '[Tag] Fetch tags';
}
